<template>
  <Layout>
    <div style="width: 100%; margin-top: 55px">
      <div class="vehicle-batch-header">
        <q-btn color="secondary" @click="$store.commit('vehicle/OPEN_EXCEL_MODAL', true)">Excel Import</q-btn>
        <q-btn class="q-mx-md" round icon="fas fa-sync" color="info" @click="batchList"></q-btn>
        <q-btn-dropdown color="primary" label="Download Template Examples">
          <q-list>
            <q-item clickable v-close-popup @click="templateBatch('assumption')">
              <q-item-section>
                <q-item-label>Assumption</q-item-label>
              </q-item-section>
            </q-item>
            <q-item clickable v-close-popup @click="templateBatch('lease')">
              <q-item-section>
                <q-item-label>Lease</q-item-label>
              </q-item-section>
            </q-item>
            <q-item clickable v-close-popup @click="templateBatch('flooring')">
              <q-item-section>
                <q-item-label>Flooring</q-item-label>
              </q-item-section>
            </q-item>
            <q-item clickable v-close-popup @click="templateBatch('finance')">
              <q-item-section>
                <q-item-label>Finance</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </div>
      <q-card class="flexbox justify-center " style="min-height: 250px">
        <q-inner-loading
            :showing="loading"
            label="Please wait..."
            label-class="text-teal"
            label-style="font-size: 1.1em"
        />
        <div v-if="count > 0 && !loading">
          <q-table
              ref="table"
              title="Financial Batch"
              :data="items"
              :columns="columns"
              row-key="name"
              :pagination="{ page: 1, rowsPerPage: 0 }"
              hide-bottom
              class="no-shadow"
          >
            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td key="company" :props="props" style="width: 25%">
                  <span style="font-weight: bold">
                    {{ props.row.company }}
                  </span>
                </q-td>
                <q-td key="status" :props="props" style="width: 25%">
                  <span
                      v-if="props.row.status"
                      :style="{
                      color: statusColor(props.row.status),
                      textTransform: 'capitalize',
                      fontWeight: 'bold'
                    }"
                  >{{ props.row.status }}</span
                  >
                </q-td>
                <q-td key="type" :props="props" style="width: 25%">
                  <span style="text-transform: capitalize; font-weight: bold">
                    {{ props.row.type }}
                  </span>
                </q-td>
                <q-td key="created_at" :props="props" style="width: 25%">
                  <span style="text-transform: capitalize; font-weight: bold">
                    {{ props.row.created_at | dateTimeFormat }}
                  </span>
                </q-td>
                <q-td key="id" :props="props">
                  <q-btn
                      size="sm"
                      v-if="props.row.status === 'waiting'"
                      @click="startBatch(props.row.id)"
                      class="q-mr-sm"
                      color="primary"
                  >Start
                  </q-btn
                  >
                  <q-btn size="sm" @click="downloadBatch(props.row.id)" class="q-mr-sm" color="info">Download</q-btn>
                  <q-btn
                      size="sm"
                      @click="$router.push('/vehicles/financial-batch/' + props.row.id)"
                      class="q-mr-sm"
                      color="secondary"
                  >Show
                  </q-btn>
                  <q-btn size="sm" @click="deleteBatch(props.row.id)" class="q-mr-sm" color="negative">Delete</q-btn>
                </q-td>
              </q-tr>
            </template>
          </q-table>
          <div class="q-pa-lg flex flex-center" v-if="!this.loading">
            <q-pagination
                v-model="pagination.page"
                :max="pagination.last"
                :max-pages="5"
                @input="batchList"
                boundary-numbers
                direction-links
            />
          </div>
        </div>
        <p class="self-center" v-if="count === 0 && !loading">Data not found.</p>
      </q-card>
    </div>
    <financial-excel :updateTable="batchList"></financial-excel>
  </Layout>
</template>

<script>
import Layout from '../components/Layout'
import FinancialExcel from '../components/FinancialExcel'
import axios from '../axios/index'

export default {
  components: {
    Layout,
    FinancialExcel
  },

  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        per: 10,
        last: 0
      },
      count: 0,
      columns: [
        {name: 'company', label: 'Company', field: 'company'},
        {name: 'status', label: 'Status', field: 'status'},
        {name: 'type', label: 'Type', field: 'type'},
        {name: 'created_at', label: 'Created at', field: 'created_at'},
        {name: 'id', label: 'Actions', field: 'id'}
      ],
      items: []
    }
  },
  mounted() {
    this.batchList()
  },
  methods: {
    async batchList() {
      this.loading = true
      this.items = []
      try {
        const {data} = await axios.get('/vehicle-finance/batch', {
          params: {
            per: this.pagination.per,
            page: this.pagination.page
          }
        })

        this.pagination.last = data.data.pagination.last
        this.count = data.data.count

        if (data.data.items.length > 0) {
          for (const key in data.data.items) {
            this.items.push({
              company: data.data.items[key].company ? data.data.items[key].company.name : '',
              status: data.data.items[key].status,
              type: data.data.items[key].type,
              created_at: data.data.items[key].created_at,
              id: data.data.items[key].id
            })
          }
        }
      } catch (err) {
        this.$q.notify({
          message: err.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
      } finally {
        this.loading = false
      }
    },
    async deleteBatch(id) {
      try {
        const {data} = await axios.delete('/vehicle-finance/batch/' + id)
        this.$q.notify({
          message: data.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        this.batchList()
      } catch (err) {
        this.$q.notify({
          message: err.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      }
    },
    async downloadBatch(id) {
      try {
        const {data} = await axios.get('/vehicle-finance/batch/' + id + '/download', {
          responseType: 'blob'
        })
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${id}.xlsx`)
        document.body.appendChild(link)
        link.click()
      } catch (err) {
        this.$q.notify({
          message: err.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      }
    },
    async startBatch(id) {
      try {
        const {data} = await axios.patch('/vehicle-finance/batch/' + id + '/start', {})
        console.log(data)
        this.$q.notify({
          message: data.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        this.batchList()
      } catch (err) {
        console.log(err)
        this.$q.notify({
          color: 'negative',
          text: err.message
        })
      }
    },
    async templateBatch(type) {
      try {
        const {data} = await axios.get('/vehicle-finance/batch/template/' + type, {
          responseType: 'blob'
        })
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${type}-template.xlsx`)
        document.body.appendChild(link)
        link.click()
      } catch (err) {
        console.log(err)
      }
    },
    statusColor(status) {
      if (status === 'waiting') {
        return 'blue'
      } else if (status === 'progress') {
        return 'light-blue'
      } else if (status === 'finished') {
        return 'green'
      } else if (status === 'failed') {
        return 'red'
      }
    }
  }
}
</script>

<style scoped>
.vehicle-batch-header {
  width: 100%;
  display: flex;
  padding: 10px 0;
  justify-content: start;
  align-items: center;
}
</style>
